<template>
    <div class="submenuitem container-fluid d-flex justify-content-between">
        <div>
            <div style="display: flex; justify-content: space-evenly; border: 1px solid #8080804d;">
                <ul>
                    <div v-if="subitems?.submenu">
                        <li class="sub-menu h-full d-flex justify-content-center align-item-center'"
                            v-for="(item, index) in subitems.submenu" :key="index">
                            <img v-if="item.image" class="w-5 h-5 me-2" :src="require(`@/assets/images/${item.image}`)">
                            <router-link v-if="item.label != 'cup Solidale'"
                                :to="item.path !== item.url ? item.url : '#'">{{ item.label }}</router-link>
                            <a href="https://www.cupsolidale.it" target="_blank" v-if="item.label == 'cup Solidale'">
                                {{ item.label }}</a>
                        </li>
                    </div>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import { dataStore } from '@/main';
import { MenuItemModel } from '@/../../EshJSLib/models/MenuItemModel';


export default {
    name: 'SubMenu',
    props: {
        subitems: {
            type: MenuItemModel,
            required: true,
        },
    },
    computed: {
        eventData() {
            console.log("Info Menu " + dataStore.value);
            // Use the shared data from the data store
            return dataStore.value;
        }
    }
}
</script>

<style scoped lang="scss">
.router-link:hover:not(.router-link-active) {
    background-color: transparent;
}

ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
    overflow: hidden;
    background-color: white;
    color: #1A576E;
}

li {
    float: left;
}

li a {
    display: block;
    color: #1A576E;
    text-align: center;
    padding: 14px 16px;
    text-decoration: none;
    border-bottom: 2px solid transparent;
    /* Bordo trasparente */
    transition: border-color 0.3s ease-in-out;
    /* Aggiungi transizione */
}

/* Change the link color to #111 (black) on hover */
li a:hover {
    border-bottom: 2px solid #1A576E;
    /* Cambia solo il colore del bordo */
}

.sub-menu {
    list-style-type: none;
    margin: 0;
    font-size: 16px;
    color: #1A576E;
    text-align: center;
    transition: border-color 0.3s ease-in-out;
    border-bottom: 2px solid transparent;
    /* Bordo trasparente */

    &:hover:not(.sub-menu-active) {
        border-bottom: 2px solid #1A576E;
    }
}

.router-link-active {
    font-weight: 900;
}


.sub-menu-item {
    margin-bottom: 160px;
}

.sub-menu-active {
    color: white;
    font-weight: bold;
}
</style>